import * as $ from 'jquery';
import * as HeadroomJs from 'headroom.js';

import { NgModule } from 'ng-metadata/core';

export function ngHeadroomConfig() {
  const elem = document.getElementById('js-header');
  const headroom = new HeadroomJs(elem, {
    offset: 8,
    onTop : function() {
      $('#js-header').removeClass('is-toolbar');
    },
    onNotTop : function() {
      $('#js-header').addClass('is-toolbar');
    }
  });

  headroom.init();
}



// WEBPACK FOOTER //
// ./resources/assets/js/config/headroom.config.ts